'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RegisterForm } from '@/features/auth/components/register-form'
import { useAuth } from '@/providers/auth-provider'
import { PageLoading } from '@/components/common/page-loading-state'

export default function RegisterPage() {
  const { user, isLoading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (user) {
      router.replace('/dashboard')
    }
  }, [user, router])

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-2xl">
        {isLoading || user ? <PageLoading /> : <RegisterForm />}
      </div>
    </div>
  )
}
